import {Component} from '@angular/core';
import {CommonTableConfig} from '@lib-ui/common-table/models/common-table-config.class';
import {GroupTableService} from './group-table.service';
import {LoaderComponent} from '@lib-ui/loader/loader.component';
import {CommonTableComponent} from '@lib-ui/common-table/ui/common-table.component';
import {ICommonTableAction, ICommonTableConfig} from '@lib-ui/common-table/models/common-table.interface';
import {RowAction} from '@lib-ui/common-table/models/common-table.enum';
import {MatDialog} from '@angular/material/dialog';
import {GroupFormComponent} from './group-form/group-form.component';
import {AdvancedSearchComponent} from '@lib-ui/advanced-search/ui/advanced-search.component';
import {FilterConfig} from '@lib-ui/advanced-search/models/advanced-search.interface';
import {filter, switchMap} from 'rxjs';
import {MessageService} from '@lib-services/message.service';
import {GroupsService} from '@lib-services/groups.service';

@Component({
    selector: 'app-group',
    standalone: true,
    imports: [
        CommonTableComponent,
        LoaderComponent,
        AdvancedSearchComponent,
    ],
    templateUrl: './group.component.html',
    styleUrl: './group.component.scss'
})
export class GroupComponent {
    tableConfig: ICommonTableConfig = new CommonTableConfig( {
        columns: [
            { name: 'id', title: 'ИН' },
            { name: 'name', title: 'Группа' },
            { name: 'companyName', title: 'Компания' },
        ],
        createButtonLabel: 'Добавить группу',
        showCreateButton: true,
        withCheckboxes: true,
        rowActions: [RowAction.DELETE],
    });
    filterConfig: FilterConfig[] = [
        // {
        //     type: 'common-dropdown',
        //     label: 'Компания',
        //     name: 'company.id',
        //     commonDropdownConfig: {
        //         service: inject(CompanySelectorService),
        //         formCtrl: new FormControl(),
        //     },
        // },
    ];

    constructor(
        protected groupTableService: GroupTableService,
        protected groupsService: GroupsService,
        protected messageService: MessageService,
        private dialog: MatDialog
    ) {
    }

    applyAction(value: ICommonTableAction): void {
        if (value.action === RowAction.CLICK) {
            this.openDialog({ groupId: Number(value.data[0]['id']) });
        }
        if (value.action === RowAction.CREATE) {
            this.openDialog({});
        }
        if (value.action === RowAction.DELETE) {
            const ids = value.data.map(el => Number(el['id']));
            this.deleteGroups(ids);
        }
    }

    openDialog(data: { groupId?: number }): void  {
        this.dialog.open(GroupFormComponent, {
            width: '50%',
            height: '50%',
            maxHeight: '330px',
            data: data,
            disableClose: true,
        }).afterClosed().subscribe({
            next: () => {
                this.groupTableService.updateData(this.tableConfig);
            }
        });
    };

    applyFilters(filterData: Record<string, string | null>): void {
        this.tableConfig.filters = filterData;
        this.tableConfig.paginatorConfig.pageIndex = 0;
        this.groupTableService.updateData(this.tableConfig);
    }

    deleteGroups(ids: number[]): void {
        this.messageService.confirmMessage({
            title: 'Удаление групп(ы)',
            text: 'Вы действительно хотите удалить выбранные группы?',
            primaryText: 'Удалить',
            secondaryText: 'Отмена',
            showSecondaryButton: true,
        }).pipe(
            filter(result => result),
            switchMap(() => {
                return this.groupsService.deleteGroups(ids);
            }),
        ).subscribe({
            next: () => {
                this.messageService.successMessage('Группы успешно удалены');
                this.groupTableService.updateData(this.tableConfig);
            },
            error: () => this.messageService.errorMessage('При удалении произошла ошибка')
        });
    }

}
